<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" show-overflow :stripe="true" :border="true" height="100%"
                :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button v-if="parts_no_return_report_export" status="primary" class="button-sty" icon="el-icon-plus"
                          @click="doExcle">导出
              </vxe-button>
            </div>
            <div class="fr">
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索
              </vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
                    @submit="searchEvent" @reset="searchEvent">

            <vxe-form-item title="单据状态:">
              <template v-slot>
                <el-select
                  v-model="formData.statList"
                  multiple
                  :collapse-tags="true"
                  style="width:9vw ;"
                  placeholder="请选择">
                  <el-option :value="1" label="申请"></el-option>
                  <el-option :value="3" label="审核"></el-option>
                  <el-option :value="5" label="入库"></el-option>
                  <el-option :value="9" label="驳回"></el-option>
                  <el-option :value="99" label="取消"></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="服务中心:">
              <template v-slot>
                <org-search :org-name.sync="formData.orgName"
                            :org-id-path.sync="formData.orgIdPath"
                            :org-id.sync="formData.orgId"
                            :show="!currentIsSite"
                            @change="() => {
                              formData.siteId = null
                              formData.siteName = null
                              formData.childSiteId = null
                              formData.childSiteName = null
                            }"
                            style="width:9vw ;"
                />
              </template>
            </vxe-form-item>

            <vxe-form-item title="一级服务商:">
              <template v-slot>
                <site-pop-search :site-id.sync="formData.siteId"
                                 :site-name.sync="formData.siteName"
                                 :org-name.sync="formData.orgName"
                                 :org-id-path.sync="formData.orgIdPath"
                                 :org-id.sync="formData.orgId"
                                 :editable="!currentIsSite"
                                 :param="{siteFloorLevel: 1}"
                                 @valueChange="() => {formData.childSiteId = null; formData.childSiteName = null}"
                                 style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="下级服务商:">
              <template v-slot>
                <child-site-pop-search :site-id.sync="formData.childSiteId"
                                       :site-name.sync="formData.childSiteName"
                                       :parent-site-id.sync="formData.siteId"
                                       :org-name.sync="formData.orgName"
                                       :org-id-path.sync="formData.orgIdPath"
                                       :org-id.sync="formData.orgId"
                                       style="width:9vw ;"
                />
              </template>
            </vxe-form-item>
            <vxe-form-item title="创建时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.createTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" :clearable="false"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
            <vxe-form-item title="返厂单号:">
              <template v-slot>
                <el-input v-model="formData.returnNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>
            <vxe-form-item title="工单号:">
              <template v-slot>
                <el-input v-model="formData.orderNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="物流单号:">
              <template v-slot>
                <el-input v-model="formData.deliverNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title=" " field="name">
              <template v-slot>
                <el-input v-model="formData.sendNo" size="small" style="width:9vw ;visibility: hidden" clearable/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="更换时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.replaceTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
            <vxe-form-item title="冲账时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.offAccountingTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>

          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>

        <template #showRecallStat="{ row }">
          <span class="txt-status disable" v-if="row.recallStat == 0">未回访</span>
          <span class="txt-status neutral" v-else-if="row.recallStat == 1">已抽样</span>
          <span class="txt-status neutral" v-else-if="row.recallStat == 2">已回访</span>
          <span class="txt-status neutral" v-else-if="row.recallStat == 5">用户已评价</span>
        </template>

        <template #showIsCheck="{ row }">
          <span class="txt-status" v-if="row.isCheck == 1">属实</span>
          <span class="txt-status disable" v-else-if="row.isCheck == 2">不属实</span>
          <span class="txt-status neutral" v-else-if="row.isCheck == 3">无果</span>
        </template>

        <template #showIsNeedReturn="{ row }">
          <span class="txt-status" v-if="row.isNeedReturn == 1">是</span>
          <span class="txt-status disable" v-else-if="row.isNeedReturn == 0">否</span>
        </template>

        <template #showOffAccounting="{ row }">
          <span class="txt-status disable" v-if="row.offAccounting == 2">冲账失败</span>
          <span class="txt-status neutral" v-else-if="row.offAccounting == 0">未冲帐</span>
          <span class="txt-status" v-else-if="row.offAccounting == 1">冲账成功</span>
        </template>

        <template #showGuaranteeType="{ row }">
          <span class="txt-status " v-if="row.guaranteeType == 1">保内</span>
          <span class="txt-status disable" v-else-if="row.guaranteeType == 2">保外</span>
          <span class="txt-status neutral" v-else-if="row.guaranteeType == 3">未知</span>
        </template>

        <template #showSitePrice="{ row }">
          <span v-if="currentSiteLevel == 2 || currentIsSite">*</span>
          <span v-else>{{ row.sitePrice }}</span>
        </template>

        <template #showAmount="{ row }">
          <span v-if="currentSiteLevel == 2 || currentIsSite">*</span>
          <span v-else>{{ row.amount }}</span>
        </template>

        <template #showStat="{ row }">
          <span class="txt-status " v-if="row.stat == 1">登记</span>
          <span class="txt-status " v-else-if="row.stat == 2">发布</span>
          <span class="txt-status " v-else-if="row.stat == 5">已派网点</span>
          <span class="txt-status " v-else-if="row.stat == 6">网点已接单</span>
          <span class="txt-status " v-else-if="row.stat == 9">已派师傅</span>
          <span class="txt-status " v-else-if="row.stat == 10">师傅已接单</span>
          <span class="txt-status " v-else-if="row.stat == 11">已预约</span>
          <span class="txt-status " v-else-if="row.stat == 13">已出发</span>
          <span class="txt-status " v-else-if="row.stat == 17">已上门</span>
          <span class="txt-status neutral" v-else-if="row.stat == 20">完工暂存</span>
          <span class="txt-status neutral" v-else-if="row.stat == 30">寄修待确认</span>
          <span class="txt-status neutral" v-else-if="row.stat == 31">待寄件</span>
          <span class="txt-status neutral" v-else-if="row.stat == 32">已寄待签收</span>
          <span class="txt-status neutral" v-else-if="row.stat == 36">待维修</span>
          <span class="txt-status neutral" v-else-if="row.stat == 37">修好待寄出</span>
          <span class="txt-status neutral" v-else-if="row.stat == 38">客户待签收</span>
          <span class="txt-status neutral" v-else-if="row.stat == 40">退换待确认</span>
          <span class="txt-status neutral" v-else-if="row.stat == 41">旧机待退回</span>
          <span class="txt-status neutral" v-else-if="row.stat == 42">旧机待签收</span>
          <span class="txt-status " v-else-if="row.stat == 43">旧机已签收</span>
          <span class="txt-status neutral" v-else-if="row.stat == 44">新机待寄出</span>
          <span class="txt-status " v-else-if="row.stat == 45">新机已寄出</span>
          <span class="txt-status neutral" v-else-if="row.stat == 47">新机待签收</span>
          <span class="txt-status " v-else-if="row.stat == 48">新机已签收</span>
          <span class="txt-status disable" v-else-if="row.stat == 49">退换被驳回</span>
          <span class="txt-status " v-else-if="row.stat == 61">已完工</span>
          <span class="txt-status " v-else-if="row.stat == 62">网点确认完工</span>
          <span class="txt-status neutral" v-else-if="row.stat == 63">中心完工审核</span>
          <span class="txt-status neutral" v-else-if="row.stat == 64">总部完工审核</span>
          <span class="txt-status neutral" v-else-if="row.stat == 91">待结算</span>
          <span class="txt-status disable" v-else-if="row.stat == 92">结算驳回</span>
          <span class="txt-status disable" v-else-if="row.stat == 93">结算中止</span>
          <span class="txt-status " v-else-if="row.stat == 94">已结算</span>
          <span class="txt-status disable" v-else-if="row.stat == 97">申请关闭</span>
          <span class="txt-status disable" v-else-if="row.stat == 98">挂起</span>
          <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
          <span class="txt-status disable" v-else-if="row.stat == 100">结束</span>

          <!-- <span v-if="row.urgeTimes > 0" class="txt-status reminder">{{ row.urgeTimes }}</span> -->


        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
import {initVxeTable} from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import ChildSitePopSearch from "@/components/formItem/childSitePopSearch.vue";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import {siteMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'

export default {
  name: 'partsApplyReport',
  mixins: [siteMixins],
  components: {ChildSitePopSearch, SitePopSearch, OrgSearch, pager},
  data() {
    return {
      parts_no_return_report_export: false,
      getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量

        statList: null,
        orderTypeList: null,
        planTypeList: null,
        applyTypeList: null,
        createTime: null,
        applyNo: null,
        orgIdPath: null,
        siteId: null,
        childSiteId: null,
        checkTime: null,
        orderNo: null,
        sendNo: null,
        collectNo: null,
        deliverNo: null,
        collectTime: null,
        replaceTime: null,
        offAccountingTime: null,
      },
      formData: {
        statList: null,
        orderTypeList: null,
        planTypeList: null,
        applyTypeList: null,
        createTime: null,
        applyNo: null,
        orgIdPath: null,
        siteId: null,
        childSiteId: null,
        checkTime: null,
        orderNo: null,
        sendNo: null,
        collectNo: null,
        deliverNo: null,
        collectTime: null,
        replaceTime: null,
        offAccountingTime:null,
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      columns: [
        {title: '工单号', field: 'orderNo', width: 190,},
        {title: '工单状态', field: 'stat', width: 150, slots: {default: 'showStat'}},
        {title: '创建时间', field: 'createTime', width: 190,},
        {title: '冲账时间', field: 'offAccountingTime', width: 120,},
        {title: '服务中心', field: 'orgName', width: 150,},
        {title: '一级服务商', field: 'bigSiteName', width: 150,},
        {title: '服务商', field: 'siteName', width: 150,},
        {title: '新件编码', field: 'partsCode', width: 120,},
        {title: '新件名称', field: 'partsName', width: 120,},
        {title: '新件条码', field: 'barcode', width: 120,},
        {title: '旧件编码', field: 'oldPartsCode', width: 120,},
        {title: '旧件名称', field: 'oldPartsName', width: 120,},
        {title: '旧件条码', field: 'barcode2', width: 120,},
        {title: '价格', field: 'sitePrice', width: 90, slots: {default: 'showSitePrice'}},
        {title: '更换数量', field: 'qty', width: 100,},
        {title: '金额', field: 'amount', width: 100, slots: {default: 'showAmount'}},
        {title: '是否需要返厂', field: 'isNeedReturn', width: 110, slots: {default: 'showIsNeedReturn'}},
        {title: '冲账状态', field: 'offAccounting', width: 120, slots: {default: 'showOffAccounting'}},
        {title: '冲账单号', field: 'offAccountingNo', width: 120,},
        {title: '是否属实', field: 'isCheck', width: 110, slots: {default: 'showIsCheck'}},
        {title: '回访人', field: 'recaller', width: 120,},
        {title: '更换时间', field: 'partsCreateTime', width: 120,},
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  created() {
    this.parts_no_return_report_export = this.permissions['parts_no_return_report_export']
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
      this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
      this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
      this.$objCopy(this.formData, this.requestParam)
    },

    //导出
    doExcle() {
      this.$mask.open()
      doCheckExcle(fileNames.noReturnPartsReport).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.partsNoReturnReport.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createTime = [start, end]
      this.requestParam.createTime = [start, end]
    },
    mergeRowMethod({row, _rowIndex, column, visibleData}) {
      // const fields = ['applyQty', 'checkQty', 'collectQty', 'outQty', 'getQty']
      const cellValue = row[column.property]
      // if (cellValue && !fields.includes(column.property)) {
      const prevRow = visibleData[_rowIndex - 1]
      let nextRow = visibleData[_rowIndex + 1]
      if (prevRow && prevRow[column.property] === cellValue) {
        return {rowspan: 0, colspan: 0}
      } else {
        let countRowspan = 1
        while (nextRow && nextRow[column.property] === cellValue) {
          nextRow = visibleData[++countRowspan + _rowIndex]
        }
        if (countRowspan > 1) {
          return {rowspan: countRowspan, colspan: 1}
        }
      }
      // }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.partsNoReturnReport.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchBarcode = ''
      this.searchItemName = ''
      this.searchItemCode = ''
      this.requestParam.searchCount = false
      this.requestParam.barcode = ''
      this.requestParam.itemCode = ''
      this.requestParam.itemName = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  },

  mounted() {
    this.initSearchDate()
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}


</style>
